import { render } from "./layout-guest.vue?vue&type=template&id=1d924872&scoped=true"
import script from "./layout-guest.vue?vue&type=script&lang=js"
export * from "./layout-guest.vue?vue&type=script&lang=js"

import "./layout-guest.vue?vue&type=style&index=0&id=1d924872&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/MBx/MBx/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d924872"]])

export default __exports__